// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Countdown_wrapper__OGQMe","text":"Countdown_text__9VRMC","measure":"Countdown_measure__TLpnW","time":"Countdown_time__s2IPO"};